import { ReactElement, useContext, useRef, useState } from "react";
import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getConfiguration } from "../../configuration/configuration";
import { SystemContext } from "../../context/systemContext";
import { useAsyncFetch } from "../../system/useFetch";

const LanguageComponent = (): ReactElement => {
  const systemContext = useContext(SystemContext);
  const anchorRefLang = useRef<HTMLButtonElement>(null);
  const [openLang, setOpenLang] = useState(false);
  const [updateUserConfig ] = useAsyncFetch();

  const handleLanguage = (lang: "es-mx" | "pt-br" | "en-us") => {
    updateUserConfig({
      module: "security",
      query: "updateUserConfig",
      payload: {
        ...systemContext.user?.config,
        locale: {
          ...systemContext.user?.config.locale,
          language: lang
        }
      }
    }).then(() => systemContext.setLanguage(lang));
    setOpenLang(false);
  };

  const selectedLang = getConfiguration().flags[systemContext.languageCode];

  return (
    <>
      <Button ref={anchorRefLang} onClick={() => setOpenLang((prevOpen) => !prevOpen)}>
        <p className="mr-1" style={{ fontSize: "1.5em" }}>{selectedLang.icon}</p>
        {selectedLang.name}
        <ExpandMoreIcon/>
      </Button>
      <Popper open={openLang} anchorEl={anchorRefLang.current} role={undefined} transition={true} disablePortal={true}>
        {({ TransitionProps, placement }) =>
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpenLang(false)}>
                <MenuList autoFocusItem={openLang} id="menu-list-grow" onKeyDown={() => setOpenLang(false)}>
                  <MenuItem value="es-mx" onClick={() => handleLanguage("es-mx")}>
                    <p className="mr-2">{getConfiguration().flags["es-mx"].icon}</p>
                    {getConfiguration().flags["es-mx"].name}
                  </MenuItem>
                  <MenuItem value="pt-br" onClick={() => handleLanguage("pt-br")}>
                    <p className="mr-2">{getConfiguration().flags["pt-br"].icon}</p>
                    {getConfiguration().flags["pt-br"].name}
                  </MenuItem>
                  <MenuItem value="en-us" onClick={() => handleLanguage("en-us")}>
                    <p className="mr-2">{getConfiguration().flags["en-us"].icon}</p>
                    {getConfiguration().flags["en-us"].name}
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        }
      </Popper>
    </>
  );
};

export default LanguageComponent;
